module.exports = __webpack_public_path__ + "img/director.7b8ca796.jpg";